import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LatestHyperlapseQueryVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
}>;


export type LatestHyperlapseQuery = { __typename?: 'QueryRoot', latestHyperlapse: { __typename?: 'HyperlapseLatestInCoursePayload', hyperlapse?: { __typename?: 'Hyperlapse', id: string, startCoordinate: { __typename?: 'Coordinate', lat: number, lon: number }, endCoordinate: { __typename?: 'Coordinate', lat: number, lon: number }, waypointCoordinates?: Array<{ __typename?: 'Coordinate', lat: number, lon: number }> | null, imageInfomations?: Array<{ __typename?: 'OneFigPath', success: boolean, fileName: string, index: number, heading: number, location: { __typename?: 'CreateHyperlapseCoordinate', lat: number, lng: number } }> | null } | null } };

export type CreateHyperlapseMutationVariables = Types.Exact<{
  input: Types.GenerateHyperlapseInput;
}>;


export type CreateHyperlapseMutation = { __typename?: 'MutationRoot', generateHyperlapse: { __typename?: 'Hyperlapse', id: string } };


export const LatestHyperlapseDocument = gql`
    query LatestHyperlapse($courseId: String!) {
  latestHyperlapse(courseId: $courseId) {
    hyperlapse {
      id
      startCoordinate {
        lat
        lon
      }
      endCoordinate {
        lat
        lon
      }
      waypointCoordinates {
        lat
        lon
      }
      imageInfomations {
        success
        fileName
        index
        heading
        location {
          lat
          lng
        }
      }
    }
  }
}
    `;

export function useLatestHyperlapseQuery(options: Omit<Urql.UseQueryArgs<LatestHyperlapseQueryVariables>, 'query'>) {
  return Urql.useQuery<LatestHyperlapseQuery, LatestHyperlapseQueryVariables>({ query: LatestHyperlapseDocument, ...options });
};
export const CreateHyperlapseDocument = gql`
    mutation CreateHyperlapse($input: GenerateHyperlapseInput!) {
  generateHyperlapse(input: $input) {
    id
  }
}
    `;

export function useCreateHyperlapseMutation() {
  return Urql.useMutation<CreateHyperlapseMutation, CreateHyperlapseMutationVariables>(CreateHyperlapseDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLatestHyperlapseQuery((req, res, ctx) => {
 *   const { courseId } = req.variables;
 *   return res(
 *     ctx.data({ latestHyperlapse })
 *   )
 * })
 */
export const mockLatestHyperlapseQuery = (resolver: ResponseResolver<GraphQLRequest<LatestHyperlapseQueryVariables>, GraphQLContext<LatestHyperlapseQuery>, any>) =>
  graphql.query<LatestHyperlapseQuery, LatestHyperlapseQueryVariables>(
    'LatestHyperlapse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateHyperlapseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ generateHyperlapse })
 *   )
 * })
 */
export const mockCreateHyperlapseMutation = (resolver: ResponseResolver<GraphQLRequest<CreateHyperlapseMutationVariables>, GraphQLContext<CreateHyperlapseMutation>, any>) =>
  graphql.mutation<CreateHyperlapseMutation, CreateHyperlapseMutationVariables>(
    'CreateHyperlapse',
    resolver
  )
